<template>
  <section>
    <h2 class="h2Title">{{board.boardName}}</h2>
    <article-list v-if="isList" @callback-change-list="changeBoardType"/>
    <article-photos v-if="isPhotos" @callback-change-list="changeBoardType"/>
    <article-schedule v-if="isSchedule" @callback-change-list="changeBoardType"/>
  </section>
</template>

<script>
import ArticleList from "./List";
import ArticlePhotos from "./Photo";
import ArticleSchedule from "./Schedule";

import boardApi from '@/api/BoardApi'


export default {
  name: "Article",
  components: {
    'article-list' : ArticleList,
    'article-photos' : ArticlePhotos,
    'article-schedule' : ArticleSchedule
  },
  data: () => ({
    isList: false,
    isPhotos: false,
    isSchedule: false,
    board:{}
  }),
  methods: {
    changeBoardType(value) {
      this.isList = 'TYPE_GENERAL' === value
      this.isPhotos = 'TYPE_PHOTO' === value
      this.isSchedule = 'TYPE_SCHEDULE' === value
    }
  },
  created: function () {

    boardApi.get(this.$route.params.id).then(data => {
      this.board = data;

      // const storedParams = this.$store.getters?.params??{};
      // const boardType = storedParams?.boardType??this.board.boardType;
      this.isList = this.board.boardType === 'TYPE_GENERAL'; // ['TYPE_GENERAL', 'TYPE_SCHEDULE'].includes(this.board.boardType);
      this.isPhotos = this.board.boardType === 'TYPE_PHOTO';
      this.isSchedule = this.board.boardType === 'TYPE_SCHEDULE';
    });

  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}

.fieldWrap {
  @include form-bx;

  .fieldBx {
    position: relative;
    width: 1600px;

    .searchBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 1.7%;
    }

    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
        }

        dd {
          display: flex;
          align-items: center;

          span {
            margin-left: 8px;
          }

          &:nth-child(2) {
            padding-left: 5px;
            padding-bottom: 3px;
          }

          .monthBx {
            display: flex;
            align-items: center;
            height: 35px;
            border-radius: 3px;
            border: 1px solid #1867c0;

            .month {
              &:first-child {
                padding-left: 10px;
              }

              height: 100%;
              padding: 0 8px;
              border: 0;
              background: #fff;
              font-size: 13px;
              font-weight: normal;
              color: #1867c0;

              &.active {
                background: #1867c0;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}

.tableWrap {
  .tableBtnBx {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .searchAll {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      /*font-size: 13px;*/
      .txtPoint {
        color: $point-color;
      }
    }
  }

  .tableBtn {
    ul {
      display: flex;
      flex-direction: row;
      align-items: center;

      .tableBtnList {
        //margin-right: 15px;
      }
    }
  }
}
</style>
